// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import AOS from 'aos'
import 'aos/dist/aos.css'
import lax from 'lax.js'

Vue.config.productionTip = false

// Register Global Components
Vue.component('navmenu', require('./components/NavMenu.vue').default)
Vue.component('footermenu', require('./components/FooterMenu.vue').default)

new Vue({
  render: h => h(App),
  created () {
		AOS.init()

		// setup lax
		lax.setup()

		document.addEventListener('scroll', function () {
			lax.update(window.scrollY)
		}, false)
	},
	router,
	components: { App },
	template: '<App/>'

}).$mount('#app')
